import { useCallback, useEffect, Fragment, memo, FC, useState, useMemo } from 'react'
import { useRouter } from 'next/router'

import { useUserPermissionsManager } from 'contexts/UserPermissionsManager/Provider'
import { getModuleByPathOnURL } from 'utils/module'
import { CustomFeedback } from 'components/feedback'

type Props = {
  children: JSX.Element
  permissions?: (string | undefined)[]
  moduleName?: string
  showCustomFeedback?: boolean
}

const HasPermissionsToSeeThisComponent: FC<Props> = ({ showCustomFeedback = false, children, permissions }) => {
  const [hasPermission, setHasPermission] = useState(false)

  const { asPath } = useRouter()

  const MODULE = useMemo(() => {
    const moduleOnUrl = asPath.split('/')[1]
    return getModuleByPathOnURL(moduleOnUrl)
  }, [asPath])

  const ADMIN_PERMISSION = `IMPACTO-${MODULE.API_NAME}-ADMIN`

  const { userPermissions } = useUserPermissionsManager()

  const checkUserHasPermissions = useCallback(() => {
    if (!userPermissions) return true
    if (!permissions) return true

    return userPermissions.some((item) => userPermissions.includes(ADMIN_PERMISSION) || permissions.includes(item), [])
  }, [permissions, userPermissions])

  useEffect(() => {
    async function checkPermission() {
      const hasPermission = checkUserHasPermissions()
      setHasPermission(hasPermission)
    }

    checkPermission()
  }, [checkUserHasPermissions])

  if (!hasPermission) {
    if (showCustomFeedback) {
      return <CustomFeedback context="withoutPermission" />
    }
    return null
  }

  return <Fragment>{children}</Fragment>
}

export default memo(HasPermissionsToSeeThisComponent)
